import axios from 'axios';

import order from './mock-data/order.json';
import config from '../config';

class OrderApi {
  static get(orderId, restaurantCode) {
    if (config.mockApi) {
      return Promise.resolve(order);
    }

    return axios
      .get(`${config.apiUrl}/order/${orderId}`, {headers: {'X-FOODit-Restaurant-Code': restaurantCode}})
      .then(res => res.data);
  }
}

export default OrderApi;



// WEBPACK FOOTER //
// ./api/order.api.js